import React from 'react';

const WorkFlowIcon = (props) => {
    return (
        <svg {...props} xmlns="http://www.w3.org/2000/svg" width={props.width ? props.width : '24'}
             height={props.height ? props.height : '24'} viewBox="0 0 24 24" fill="none"
             stroke={props.stroke ? props.stroke : 'currentColor'}
             strokeWidth={props.strokeWidth ? props.strokeWidth : '2'} strokeLinecap="round"
             strokeLinejoin="round"
        >
            <rect width="8" height="8" x="3" y="3" rx="2"/>
            <path d="M7 11v4a2 2 0 0 0 2 2h4"/>
            <rect width="8" height="8" x="13" y="13" rx="2"/>
        </svg>
    );
};

export default WorkFlowIcon;



// WEBPACK FOOTER //
// ./src/assets/icons/WorkflowIcon.jsx